import { 
    GET_DEVICE_DATA, GET_DEVICE_DATA_FAILED,
    PREV_PAGE_DATA, PREV_PAGE_DATA_FAILED, SEND_MESSAGE, SEND_MESSAGE_FAILED
} from "../actions";

const INITIAL_STATE = {
    device: {
        platform: '',
        modal: ''
    },
    helperIcons: {
        spaced:"<p>Spaced Questions allow you to determine the next time this qestion will be shown to you. </p><p>You can select 1 hour, 1 day, 1 week, 2 weeks, or 1 month.<p>",
        open:"<p>Answers, Explanations and References will be presented after each question.</p>",
        closed:"<p>Answers, Explanations and References will not be presented after each question.</p>",
        public:"<p>A Public deck is shown on the master of list of Decks available to anyone.</p> <p>Users may select to subscribe to the Deck or may a copy of the Deck.</p>",
        home:"<p>This deck will be pinned to the Home page for easy access.</p>",
        flashcards:"<p>For Study purposes only. Question is presented followed by “flipping” over to display the correct answer only, rationale and references.</p>",
        deckEnds: "<p>If selected, the deck will end once all of the questions have been answered.</p> <p>If not selected, the deck will continue indefinitely.</p>",
        quizzes: "<p>Each time a quiz starts, up to 10 questions are randomly selected from the chosen topic area.</p><p>Unlike decks, a quiz ends after the submission of the final question.</p><p>Answers, Explanations and References may or may not be presented after each question based on the quiz settings.</p>",
        mydecks: "<p>This is a list of your custom-built decks that have been added to the home page.</p> <p>For a full list of your decks see the <strong>My Decks</strong> page.</p> <p>Answers, Explanations and References may or may not be presented after each question based on the deck settings.</p>",
        prebuilt: "<p>These decks are prebuilt decks based upon topic area.</p> <p>Answers, Explanations and References will be presented after each question.</p>"
    },
    prevPage: {},
    sendMessage: null
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case GET_DEVICE_DATA: {
            return { ...state, device: action.payload}
        }

        case PREV_PAGE_DATA: {
            return { ...state, prevPage: action.payload}
        }

        case SEND_MESSAGE: {
            return {
                ...state, sendMessage: action.payload
            }
        }

        case PREV_PAGE_DATA_FAILED:
        case GET_DEVICE_DATA_FAILED: 
        case SEND_MESSAGE_FAILED: {
            return { ...state, error: action.payload }
        }
        default: {
            return state; 
        }
    }
}